import React from "react"
import { useSelector } from "react-redux"
import _ from "lodash"
import * as Adm from "@adm"
import SwitchTenant from "./SwitchTenant"
const TenantBreadcrumb = ({
  list = [],
  fallbackList = null,
  breadcrumbTabName = "",
  breadcrumbTabUrl = "",
  breadcrumbTabOnClick = null,
  additionalCrumbs = [],
  txnId = "",
  tenantUrl = "",
  showRealm = false,
  onUpdate = () => "",
  isSubPage = true,
  removeRealmEvent = false,
}) => {
  const userProfileDetails =
    useSelector((state) => state.adminReducer.userProfileDetails) || {}

  const isSAASRole =
    _.includes(localStorage.getItem("sourceRole"), "SaaS-Site-Admin") ||
    _.includes(localStorage.getItem("sourceRole"), "Sub-SaaS-Admin")

  // Realm crumb only for SaaS-Site-Admin when showRealm is enabled.
  // Sub-SaaS keeps Tenant only (no empty Realm slot / auto-selected Default crumb).
  const isSaaSSiteAdmin = _.includes(
    localStorage.getItem("sourceRole"),
    "SaaS-Site-Admin"
  )
  const showRealmCrumb = showRealm && isSaaSSiteAdmin

  if (isSAASRole === false && fallbackList !== null) {
    return <Adm.Breadcrumb list={fallbackList} />
  }

  const resolvedTenantUrl = tenantUrl
    ? `/${userProfileDetails?.roleType}/${tenantUrl}`
    : `/${userProfileDetails?.roleType}/tenantTransactions`

  const resolvedTenantName =
    localStorage.getItem("selectedTenantName") ||
    localStorage.getItem("transactionTenantName") ||
    localStorage.getItem("alerts-tenant-id") ||
    ""
  const resolvedTenantStatus =
    localStorage.getItem("selectedTenantStatus") || "Active"

  let subUrl = isSubPage ? { url: resolvedTenantUrl, disable: true } : {}
  const fullList = [
    ...list,
    ...(isSAASRole
      ? [
          ...(showRealmCrumb
            ? [
                {
                  name: localStorage.getItem("defaultRealmValue")
                    ? `Realm: ${localStorage.getItem("defaultRealmValue")}`
                    : "Realm",
                },
              ]
            : []),
          {
            name: resolvedTenantName
              ? `Tenant: ${resolvedTenantName}`
              : "Tenant",
            // url: resolvedTenantUrl,
            ...subUrl,
          },
        ]
      : []),
    ...(breadcrumbTabName
      ? [
          {
            name: `${breadcrumbTabName}`,
            ...(breadcrumbTabUrl ? { url: breadcrumbTabUrl } : {}),
            ...(breadcrumbTabOnClick ? { onClick: breadcrumbTabOnClick } : {}),
          },
        ]
      : []),
    ...additionalCrumbs,
    ...(txnId
      ? [
          {
            name: txnId,
            disable: true,
            url: "",
          },
        ]
      : []),
  ]

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {isSAASRole && resolvedTenantName && (
        <>
          {/* 5 >= fullList.length */}
          {true && (
            <SwitchTenant
              tenantName={resolvedTenantName}
              tenantUrl={resolvedTenantUrl}
              status={resolvedTenantStatus}
            />
          )}
        </>
      )}
      <Adm.Breadcrumb list={fullList} onUpdate={onUpdate} />
    </div>
  )
}

export default TenantBreadcrumb
export { TenantBreadcrumb }
